import * as Const from '../shared/constants';

export interface IArticulo {
    id?: number,
    swLote?: string,
    swEntradasDirectas?: string,
    swDefectuoso?: string,
    id_cliente?: number,
    ean?: string,
    sku?: string,
    descripcion?: string,
    swActivo?: boolean,

    unidadesCaja?: number,
    unidadesPale?: number,
    alto?: number,
    ancho?: number,
    largo?: number,
    peso?: number,
    volumen?: number,

    foto?: string,
    url?: string,
    cliNombre?: string,
    artStock?: number,
    origen?: string,

    created_at?: string,
    updated_at?: string


    // Aux
    readOnlyFecCaducidad?: boolean,
}


// Asignar valores por defecto
export const articuloPorDefecto: IArticulo = {
    swLote: '',
    swEntradasDirectas: '',
    swDefectuoso: Const.NO_DEFECTUOSO,
    id_cliente: 0,
    ean: '',
    sku: '',
    descripcion: '',
    swActivo: true,
    unidadesCaja: 0,
    alto: 0,
    ancho: 0,
    largo: 0,
    peso: 0,
    volumen: 0,
    foto: '',
    url: '',
    cliNombre: '',
    artStock: 0,
    created_at: '',
    updated_at: ''
};
